import React, { useContext } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from '../contexts/LocalesContext'

export default function HistoricalComponent({ data, title }) {
  const { t } = useContext(LocalesContext)

  return (
    <>
      {data && data.length != 0 ? (
        <table className="c-table">
          <thead>
            <tr>
              <th>{ title }</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((d, i) => {
              return (
                <tr key={i}>
                  <td>
                    {d.value}
                    {d.subvalue && (
                      <>
                        <br />
                        <small>{d.subvalue}</small>
                      </>
                    )}
                  </td>
                  <td>{d.date}</td>
                  <td className="mobile">
                    <span><p>{ title }</p><p></p></span>
                    <span><p>{d.value}{d.subvalue && (<><br /><small>{d.subvalue}</small></>)}</p><p>{d.date}</p></span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
           <table className="c-table">
              <thead>
                <tr>
                  <th>{ title }</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="2" className="c-table__cell--empty">
                    {t("application.messages.no_data_to_show")}
                  </td>
                </tr>
              </tbody>
            </table>
      )}
    </>
  );
}

HistoricalComponent.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

HistoricalComponent.defaultProps = {
  data: [],
  title: '',
};